import pelette from 'App/theme/palette';

export const iconProperties = [
  { name: 'setup', background: pelette.warning.main, color: 'black' },
  { name: 'restricted', background: pelette.info.main, color: 'white' },
  { name: 'available', background: pelette.primary.main, color: 'white' },
  { name: 'disabled', background: pelette.grey[500_24], color: 'black' },
  { name: 'full', background: pelette.error.main, color: 'white' },
];
